import { render, staticRenderFns } from "./PracticeSummary.vue?vue&type=template&id=3fa14083&scoped=true&"
import script from "./PracticeSummary.vue?vue&type=script&lang=js&"
export * from "./PracticeSummary.vue?vue&type=script&lang=js&"
import style0 from "./PracticeSummary.vue?vue&type=style&index=0&id=3fa14083&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa14083",
  null
  
)

export default component.exports